export const getBlogPostNextjsUrl = (blogId: number) => `/blogs/${blogId}?section=posts`
